import * as React from 'react';
import { NotifierToast, NotifierToastProps } from './NotifierToast';

export type NotifierToastSuccessProps = Omit<NotifierToastProps, 'type'>;

export function NotifierToastSuccess(props: NotifierToastSuccessProps): JSX.Element {
    return <NotifierToast dataCy="success-notifier-toast" type="success" {...props} />;
}
NotifierToastSuccess.displayName = 'NotifierToastSuccess';
